(function () {
  'use strict';
  var W = window, D = document;
  if (W.__pelunio) return;
  W.__pelunio = true;

  var reduce = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var HAS_IO = 'IntersectionObserver' in W;
  var registry = new Map();

  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  function listen(store, el, type, fn, opts) {
    el.addEventListener(type, fn, opts);
    store.push(function () { el.removeEventListener(type, fn, opts); });
  }
  function observe(store, els, cb, opts) {
    if (!HAS_IO || !els.length) return null;
    var io = new IntersectionObserver(cb, opts || {});
    els.forEach(function (e) { io.observe(e); });
    store.push(function () { io.disconnect(); });
    return io;
  }

  D.documentElement.classList.add('pelunio-js');

  /* Aparicion progresiva al hacer scroll */
  function reveal(el, store) {
    var items = $$('[data-pelunio-reveal]', el);
    if (!items.length) return;
    if (!HAS_IO || reduce) { items.forEach(function (i) { i.classList.add('is-in'); }); return; }
    var io = observe(store, items, function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }

  /* Anadir al carrito (misma API y mismo aviso de carrito que el tema) */
  function setBusy(btns, on) {
    btns.forEach(function (b) { if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
  }
  function flashDone(btns) {
    btns.forEach(function (b) {
      var l = $('[data-pl-label]', b);
      if (!l) return;
      if (!l.dataset.orig) l.dataset.orig = l.textContent;
      l.textContent = l.dataset.done || 'Añadido';
      b.classList.add('is-done');
      setTimeout(function () { l.textContent = l.dataset.orig; b.classList.remove('is-done'); }, 2400);
    });
  }
  function addToCart(form, btns, say) {
    if (btns[0].getAttribute('aria-busy') === 'true') return;
    var fd = new FormData(form);
    if (!fd.get('id')) { say('Elige un modelo para continuar.', true); return; }
    var cart = $('cart-notification') || $('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', W.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(D.activeElement);
    }
    var cartUrl = (W.routes && W.routes.cart_url) || '/cart';
    setBusy(btns, true);
    say('', false);
    fetch(((W.routes && W.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) throw new Error(j.description || j.message || 'No se ha podido añadir el producto.');
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pelunio', productVariantId: fd.get('id'), cartData: j });
          }
        } catch (e) { /* aviso opcional */ }
        if (cart && j.sections) {
          cart.renderContents(j);
        } else {
          W.location.href = cartUrl;
          return;
        }
        flashDone(btns);
        say('Añadido al carrito.', false);
      })
      .catch(function (err) { say(err.message || 'No se ha podido añadir. Inténtalo de nuevo.', true); })
      .then(function () { setBusy(btns, false); });
  }

  /* Hero: galeria, variantes, cantidad, compra, barra fija y parallax */
  function hero(el, store) {
    var slides = $$('[data-pl-slide]', el), thumbs = $$('[data-pl-thumb]', el), fade = 0;
    function show(i) {
      var t = slides[i];
      if (!t || t.classList.contains('is-active')) return;
      clearTimeout(fade);
      slides.forEach(function (s) { if (s !== t && s.classList.contains('is-active')) s.classList.remove('is-active'); });
      t.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { t.classList.add('is-active'); });
      });
      fade = setTimeout(function () { slides.forEach(function (s) { if (s !== t) s.hidden = true; }); }, reduce ? 0 : 480);
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    store.push(function () { clearTimeout(fade); });
    thumbs.forEach(function (b, k) { listen(store, b, 'click', function () { show(k); }); });

    var form = $('[data-pl-form]', el), status = $('[data-pl-status]', el);
    function say(msg, err) {
      if (!status) return;
      status.textContent = msg;
      status.classList.toggle('is-error', !!err);
    }
    function current() {
      return $('input[name="id"]:checked', el) || $('select[name="id"] option:checked', el);
    }
    function sync() {
      var c = current();
      if (!c || !c.dataset.price) return;
      $$('[data-pl-price]', el).forEach(function (p) { p.textContent = c.dataset.price; });
      $$('[data-pl-model]', el).forEach(function (p) { p.textContent = c.dataset.title || ''; });
      if (c.dataset.media) {
        for (var i = 0; i < slides.length; i++) { if (slides[i].dataset.media === c.dataset.media) { show(i); break; } }
      }
    }
    $$('[name="id"]', el).forEach(function (r) { listen(store, r, 'change', sync); });

    var qty = $('[data-pl-qty]', el);
    if (qty) {
      listen(store, qty, 'click', function (e) {
        var b = e.target.closest('[data-pl-step]');
        if (!b) return;
        var inp = $('input', qty), v = (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.plStep, 10);
        inp.value = Math.min(Math.max(v, parseInt(inp.min, 10) || 1), parseInt(inp.max, 10) || 99);
      });
    }

    var addBtn = $('[data-pl-add]', el), barBtn = $('[data-pl-bar-add]', el);
    var btns = [addBtn, barBtn].filter(Boolean);
    if (form && addBtn) {
      listen(store, form, 'submit', function (e) {
        if (e.submitter && e.submitter.name && e.submitter.name !== 'add') return;
        e.preventDefault();
        addToCart(form, btns, say);
      });
      if (barBtn) listen(store, barBtn, 'click', function () { addToCart(form, btns, say); });
    }

    /* Barra de compra fija en movil: solo cuando no se ve el bloque de compra ni el cierre */
    var bar = $('[data-pl-bar]', el), buy = $('[data-pl-buybox]', el);
    if (bar && buy && HAS_IO) {
      var vBuy = false, vEnd = false;
      var upd = function () { bar.classList.toggle('is-on', !vBuy && !vEnd); };
      observe(store, [buy], function (en) { vBuy = en[0].isIntersecting; upd(); });
      observe(store, $$('[data-pelunio-cta-end]'), function (en) { vEnd = en.some(function (x) { return x.isIntersecting; }); upd(); });
    }

    /* Parallax muy ligero (solo transform, solo mientras el hero esta a la vista) */
    var pars = $$('[data-pl-par]', el);
    if (pars.length && HAS_IO && !reduce) {
      var factors = pars.map(function (p) { return parseFloat(p.dataset.plPar) || 0; });
      var ticking = false, on = false;
      var frame = function () {
        ticking = false;
        var y = W.pageYOffset || 0;
        pars.forEach(function (p, i) { p.style.transform = 'translate3d(0,' + (y * factors[i]).toFixed(1) + 'px,0)'; });
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
      observe(store, [el], function (en) {
        var vis = en[0].isIntersecting;
        if (vis && !on) { W.addEventListener('scroll', onScroll, { passive: true }); on = true; onScroll(); }
        else if (!vis && on) { W.removeEventListener('scroll', onScroll); on = false; }
      });
      store.push(function () { W.removeEventListener('scroll', onScroll); });
    }
  }

  /* Comparador antes/despues */
  function compare(el, store) {
    var box = $('[data-pl-cmp]', el);
    if (!box) return;
    var range = $('input', box), stopped = false, raf = 0;
    function set(v) { box.style.setProperty('--pos', v); }
    listen(store, range, 'input', function () { stopped = true; set(range.value); });
    listen(store, range, 'keydown', function () { stopped = true; });
    listen(store, box, 'pointerdown', function () { stopped = true; }, { passive: true });
    store.push(function () { cancelAnimationFrame(raf); });
    if (reduce || !HAS_IO) return;
    function sweep() {
      var path = [50, 20, 68, 50], seg = path.length - 1, dur = 2200, t0 = null;
      function step(t) {
        if (stopped) return;
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / dur, 1) * seg, i = Math.min(Math.floor(p), seg - 1), f = p - i;
        f = f < 0.5 ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2;
        var v = Math.round(path[i] + (path[i + 1] - path[i]) * f);
        set(v);
        range.value = v;
        if (p < seg) raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    }
    var io = observe(store, [box], function (en) {
      if (en[0].isIntersecting) { io.disconnect(); sweep(); }
    }, { threshold: 0.6 });
  }

  /* Acordeon de preguntas */
  function accordion(el, store) {
    $$('[data-pl-acc]', el).forEach(function (b) {
      listen(store, b, 'click', function () {
        b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });
  }

  function init(el) {
    if (registry.has(el)) return;
    var store = [];
    registry.set(el, store);
    reveal(el, store);
    var type = el.getAttribute('data-pelunio-section');
    if (type === 'hero') hero(el, store);
    else if (type === 'compare') compare(el, store);
    else if (type === 'faq') accordion(el, store);
  }
  function initAll(root) { $$('[data-pelunio-section]', root).forEach(init); }
  function destroy(root) {
    registry.forEach(function (store, el) {
      if (root.contains(el)) { store.forEach(function (f) { f(); }); registry.delete(el); }
    });
  }

  /* Enlaces internos suaves (#pelunio-...) */
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#pelunio-"]');
    if (!a) return;
    var t = D.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
    t.focus({ preventScroll: true });
  });

  D.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  D.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  initAll(D);
})();